export default __webpack_public_path__ + "static/logo-ranking-2021-full-bb93354a4a38a7a6fba03d96efcf823e.svg";